const _import = require('./_import_' + process.env.NODE_ENV);

const publicPages = [
  {
    name: 'home',
    path: 'home',
    component: _import('views/Pages/Home'),
  },

  {
    name: 'about-us',
    path: 'about-us',
    component: _import('views/Pages/AboutUs')
  },
  {
    name: 'faqs',
    path: 'faqs',
    component: _import('views/Pages/Faqs')
  },
  {
    name: 'contact-us',
    path: 'contact-us',
    component: _import('views/Pages/ContactUs')
  },
  {
    name: 'terms-and-conditions',
    path: 'terms-and-conditions',
    component: _import('views/Pages/TermsAndConditions')
  },
  {
    name: 'privacy-policy',
    path: 'privacy-policy',
    component: _import('views/Pages/PrivacyPolicy')
  },
  {
    name: 'topup',
    path: 'topup',
    component: _import('views/Pages/TopUp')
  },
  {
    name: 'egift',
    path: 'egift',
    component: _import('views/Pages/Egift')
  }
];

const userPages = [
  {
    name: 'checkout',
    path: 'checkout',
    component: _import('views/User/UserCheckout'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'cart',
    path: 'cart',
    component: _import('views/User/UserCart'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'my-account',
    path: 'my-account',
    component: _import('views/User/UserHome'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'edit-profile',
    path: 'edit-profile',
    component: _import('views/User/UserUpdateProfile'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'change-password',
    path: 'change-password',
    component: _import('views/User/UserChangePassword'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'contacts',
    path: 'contacts',
    component: _import('views/User/UserContactManagement'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'payment-methods',
    path: 'payment-methods',
    component: _import('views/User/UserPaymentMethodManagement'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'history',
    path: 'history',
    component: _import('views/User/UserOrderHistory'),
    meta: {
      requiresAuth: true
    }
  },

  {
    name: 'service-topup',
    path: 'services/topup',
    component: _import('views/User/UserTopup'),
    meta: {
      requiresAuth: true
    }
  }
];

const adminPages = [
  {
    name: 'admin-slides',
    path: 'admin/slides',
    component: _import('views/Admin/AdminSlideManagement'),
    meta: {
      requiresAuth: true
    }
  }
];

const authPages = [
  {
    name: 'login',
    path: 'login',
    component: _import('views/Login')
  },
  {
    name: 'register',
    path: 'register',
    component: _import('views/Register')
  }
];

export default [
  {
    path: '/',
    component: _import('layout/Layout'),
    redirect: `/home`,
    children: [
      ...authPages,
      ...publicPages,
      ...userPages,
      ...adminPages,
      {
        name: '404',
        path: '404',
        component: _import('views/Pages/NotFound'),
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
      }
    ]
  },
  {
    path: '*',
    redirect: '404',
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js